import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import DashboardLink from '../../images/DashboardLink.png';

const HomepageCard = ({ data, index }) => {
    return (
        <Grid
            item
            container
            xs={12}
            sm={5.9}
            md={3.9}
            className="homepage-card m-0 d-flex flex-column justify-content-between"
            style={{ height: 'auto' }}
        >
            <Box className="d-flex justify-content-start mb-2">
                <Box className="p-3" style={{ backgroundColor: '#F2F2F2', borderRadius: '4px' }}>
                    {data.icon}
                </Box>
            </Box>
            <Box className="mb-2">
                {' '}
                <Typography variant="body1" fontSize={'1.7rem'} align="left" style={{ color: '#4F4F4F' }}>
                    {data.title}
                </Typography>
            </Box>
            <Box className="d-flex justify-content-end">
                <Link to={data.link} key={index} style={{ textDecoration: 'none', cursor: 'pointer' }}>
                    <img src={DashboardLink} alt="Link" style={{ height: '50px', width: '50px' }} />
                </Link>
            </Box>
        </Grid>
    );
};

export default HomepageCard;
